import { render } from "./modal_examen_details.vue?vue&type=template&id=12148adc"
import script from "./modal_examen_details.vue?vue&type=script&lang=js"
export * from "./modal_examen_details.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__